import styled from "styled-components"
import { Container } from "@mui/material"
import Grid from "@mui/material/Grid"

export const Background = styled(Container)`
  background-color: #ffffff;
`

export const Columns = styled(Grid)`
  padding-top: 6em;
  padding-bottom: 6em;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-top: 2em;
    padding-bottom: 2em;
  }

  .MuiGrid-item {
    padding-left: 8px;
    padding-right: 8px;

    ${({ theme }) => theme.breakpoints.down("sm")} {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .MuiGrid-root {
    h2 {
      font-size: ${({ theme }) => theme.typography.pxToRem(36)};
      font-weight: 600;
      color: #d21e1e;
    }

    p {
      font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    }

    .wrapper {
      //max-width: 496px;

      .gatsby-image-wrapper {
        max-height: 500px;
      }

      ${({ theme }) => theme.breakpoints.down("sm")} {
        margin: auto;

        .gatsby-image-wrapper {
          margin-top: 1em;
        }
      }

      &.no-reverse {
        ${({ theme }) => theme.breakpoints.up("md")} {
          margin: auto 0 auto auto;
        }
      }
    }
  }
`
